import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import '../downloadRcm.scss';

export function AboutRCM({ data }) {
  return (
    <div className='aboutRCM'>
      <div
        className='aboutRCM_title'
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.title) }}
      />
      <div
        className='aboutRCM_body'
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.body) }}
      />
    </div>
  );
}

AboutRCM.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }).isRequired,
};
